<template>
  <div class="container-performance" :class="{ 'ar-style': $i18n.locale === 'ar' }">
    <div class="custom-nav-block" :style="`paddingTop:${barHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="handleBack">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow05.png" alt="" @click-left="closeWeb" />
          {{ $t('lang.dl.hostPerformance') }}
        </template>
      </van-nav-bar>
    </div>

    <div class="policy-main right-read">
      <div class="switch-tab">
        <div class="tab" :class="{ actTab: tab == 1 }" @click="changeTab(1)">
          {{ $t('lang.dl.weekly') }}
          <span v-if="tab == 1"></span>
        </div>
        <div class="tab" :class="{ actTab: tab == 2 }" @click="changeTab(2)">
          {{ $t('lang.dl.daily') }}
          <span v-if="tab == 2"></span>
        </div>
      </div>
      <div v-if="tab == 1">
        <div class="total">
          <div class="total-num">
            {{ $t('lang.dl.total') }}:
            <img :src="getMatchImg('beans')" alt="" />
            <i>{{ weekData.weekIncome }}</i>
          </div>
          <div class="chooseWeek">
            <div class="btn" @click="selectWeek">
              {{ selectText }}
              <img :class="{ activeImg: showTime }" src="@/assets/packageAssets/common/arrow06.png" alt="" />
            </div>
            <div class="select" v-if="showTime">
              <div @click="selectTime(1)">{{ $t('lang.dl.thisWeek') }}</div>
              <div @click="selectTime(2)">{{ $t('lang.host.lastWeek') }}</div>
            </div>
          </div>
        </div>
        <TableList :data="weekData.hostIncomes" :type="'week'"></TableList>
      </div>
      <div v-if="tab == 2">
        <div class="total">
          <div class="total-num">
            {{ $t('lang.dl.total') }}:
            <img :src="getMatchImg('beans')" alt="" />
            <i>{{ dayData.dailySumIncome }}</i>
          </div>
          <div class="chooseWeek">
            <div class="btn" @click="selectDay">
              {{ handleTime4(chooseTime) }}
              <img :class="{ activeImg: showPop }" src="@/assets/packageAssets/common/arrow06.png" alt="" />
            </div>
          </div>
        </div>
        <TableList :data="dayData.hostIncomes" :type="'day'"></TableList>
      </div>
    </div>
    <CTimeDay :showPop="showPop" :minDate="minDate" @handleCurrentDate="handleCurrentDate" />
  </div>
</template>

<script>
// 这是主播代理 performance
import { apiFetchDailyIncome, apiFetchWeekIncome } from '@/api/imee'
import moment from 'moment'
import TableList from './components/TableList.vue'
import CTimeDay from '@/components/CTimeDay'
export default {
  components: { TableList, CTimeDay },
  data() {
    return {
      tab: 1,
      showTime: false,
      selectText: this.$t('lang.dl.thisWeek'),
      selectVal: 1,
      chooseTime: new Date(),
      showPop: false,
      listQuery: {
        limit: 500,
        offset: 0
      },
      weekData: {},
      dayData: {},
      minDate: new Date(2023, 0, 1)
    }
  },
  methods: {
    handleBack() {
      // 代理中心v1.0增加逻辑
      const fromPage = this.$route.query.fromPage
      if (fromPage === 'invite-v2') {
        this.goPrevious()
        return
      }
      // 旧逻辑
      this.$router.replace({
        path: '/invite',
        query: {
          tab: 2
        }
      })
    },
    // 获得周收益列表  1-本周 2-上周
    fetchWeekIncome(val) {
      let params = {
        timeType: val,
        ...this.listQuery
      }
      apiFetchWeekIncome(params).then((res) => {
        if (res) {
          this.weekData = res
        }
      })
    },

    // 获得日收益列表
    fetchDailyIncome(val) {
      let params = {
        agentDay: moment(val).format('yyyy-MM-DD'),
        ...this.listQuery
      }
      apiFetchDailyIncome(params).then((res) => {
        if (res) {
          this.dayData = res
        }
      })
    },

    // 选择tab
    changeTab(val) {
      this.showTime = false
      this.tab = val || 1
      // 周
      if (val == 1) {
        this.minDate = new Date(2023, 0, 1)
        this.fetchWeekIncome(this.selectVal)
      }
      // 日
      else {
        this.minDate = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)
        this.fetchDailyIncome(this.chooseTime)
      }
    },

    // 选择周时间 onSelect
    selectWeek() {
      this.showTime = !this.showTime
    },

    selectTime(val) {
      switch (val) {
        case 1:
          this.selectText = this.$t('lang.dl.thisWeek')
          this.selectVal = 1
          break
        case 2:
          this.selectText = this.$t('lang.host.lastWeek')
          this.selectVal = 2
          break
      }
      this.fetchWeekIncome(val)
      this.showTime = false
    },

    // 选择天时间
    selectDay() {
      this.showTime = !this.showTime
      this.showPop = true
    },
    // 关闭弹框
    closePop() {
      this.showPop = false
    },

    // 选择当前的日期
    handleCurrentDate(val) {
      this.chooseTime = val
      this.fetchDailyIncome(this.chooseTime)
    }
  },
  created() {
    this.fetchWeekIncome(1)
  },
  mounted() {
    window.document.body.scrollTo({ top: 0 })
  }
}
</script>
<style lang="scss" scoped>
// 导航栏
::v-deep .van-nav-bar__left {
  font-family: Inter;
  font-weight: bold;
  font-size: 17px;
  color: #000;
}

// 导航栏
.custom-nav-block {
  background-color: #ffffff;
}

// 内容
.container-performance {
  width: 100%;
  min-height: 812px;
  background: #fff;
  .policy-main {
    .switch-tab {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 213px;
      height: 34px;
      margin: 10px auto 0;
      .tab {
        position: relative;
        width: 97px;
        height: 26px;
        color: #999999;
        font-family: Inter;
        font-weight: 400;
        font-size: 16px;
        line-height: 16px;
        font-style: normal;
        text-align: center;
        > span {
          width: 26px;
          height: 4px;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: 0;
          background: #fd56b6;
          border-radius: 2px;
        }
      }
      .actTab {
        color: #333333;
        background: #fff;
      }
    }
    .total {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 60px;
      padding: 0 16px;
      background: #f9f9fb;
    }
    .total-num {
      display: flex;
      align-content: center;

      font-family: Inter;
      font-weight: 400;
      font-size: 17px;
      color: #999999;
      line-height: 20px;
      font-style: normal;
      > img {
        width: 20px;
        height: 20px;
      }
      i {
        color: #fd56b6;
      }
    }
    .chooseWeek {
      position: relative;
      font-size: 14px;
      .btn {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 25px;
        height: 30px;
        background: #fff;
        border-radius: 6px;
        > img {
          position: absolute;
          right: 4px;
          width: 16px;
        }
        .activeImg {
          rotate: 180deg;
        }
      }
      .select {
        position: absolute;
        z-index: 100;
        width: 107px;
        margin-top: 8px;
        background: #f9f9fb;
        border-radius: 6px;
        color: #666666;
        font-size: 14px;
        box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.1);
        > div {
          height: 30px;
          margin: 5px 0;
          line-height: 30px;
          text-align: center;
        }
      }
    }
  }
}
</style>
